<div *ngIf="isLoading">Loading Country List...</div>

<select *ngIf="!isLoading" [compareWith]="byId" class="form-control" name="country" [(ngModel)]="model.country" [required]="required">
  <option *ngFor="let singleCountry of countries" [ngValue]="singleCountry">{{ singleCountry.name }}</option>
</select>
